import { Button, Card, CardHeader, CardBody, Divider, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Input, Select, SelectItem, Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, Spinner } from "@nextui-org/react";
import { useState } from "react";
import ReactSelect from "react-select";
import { useForm, Controller } from "react-hook-form";
import { PlusIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import toast from "react-hot-toast";
import { getFetcher, getSelectFetcher, patchFetcherWithoutId, postFetcher, putFetcher, simpanSK } from "../../../../../services/api";

export default function Tembusan({ dataTembusan, isLoadingTembusan, existingTembusan, mutate, registrasiId }) {
  console.log(existingTembusan);
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    register,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      tembusanIds: existingTembusan || [],
      nip: "",
      tipe: "",
    },
  });

  const { data: tembusanList, isLoading, mutate: mutateTembusanList } = useSWR(`/api/data-master/tembusan?limit=999999`, getSelectFetcher);

  const [selectedItems, setSelectedItems] = useState(() => {
    // Check if existing data is available
    const existingPejabatIds = existingTembusan.draftSurat?.PermohonanRekomendasiTembusan?.map((tembusan) => tembusan.DataTembusan) || [];

    console.log(existingPejabatIds);
    // Map existing pejabat IDs to the format required by ReactSelect
    return existingPejabatIds?.map((tembusan) => ({
      value: tembusan.id,
      label: `${tembusan.nama}`, // Fallback to ID if label not found
    }));
  });

  const [isEdit, setIsEdit] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  const tipe = ["UMUM", "DIREKTUR"];
  const columns = ["No", "Tembusan", "Actions"];
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Handler untuk membuka modal form
  const openModalForm = async (item = null) => {
    if (item) {
      setIsEdit(true);
      setEditId(item.value);
      setIsFetching(true);

      try {
        // Mengambil data pejabat dari API menggunakan getFetcher
        const tembusanData = await getFetcher(`/api/data-master/tembusan/${item.value}`);
        reset({
          nama: tembusanData.nama,
          tipe: tembusanData.tipe,
        });
      } catch (error) {
        toast.error("Gagal mengambil data tembusan.");
      } finally {
        setIsFetching(false);
      }
    } else {
      setIsEdit(false);
      reset({ nip: "", nama: "", jabatan: "", status: "" });
    }
    setIsOpenModalForm(true);
  };

  // Handler untuk menutup modal form
  const closeModalForm = () => {
    setIsOpenModalForm(false);
    reset();
  };

  // Handler untuk submit form tambah/edit
  const onSubmitForm = async (data) => {
    try {
      if (isEdit) {
        data = {
          nama: data.nama,
          tipe: data.tipe,
        };
        await putFetcher("/api/data-master/tembusan", editId, data);
        // Update data di tabel setelah edit
        const updatedItems = selectedItems.map((item) => (item.value === editId ? { value: editId, label: `${data.nama}` } : item));
        setSelectedItems(updatedItems);
        toast.success("Tembusan berhasil diubah!");
      } else {
        const payload = {
          nama: data.nama,
          tipe: data.tipe,
        };
        const newPejabat = await postFetcher("/api/data-master/tembusan", payload);

        // Tambahkan data baru ke tabel setelah tambah
        const newItem = { value: newPejabat.id, label: `${data.nama}` };
        setSelectedItems([...selectedItems, newItem]);
        toast.success("Tembusan berhasil ditambah!");
      }
      // Mutate data list pejabat untuk memperbarui daftar di ReactSelect
      await mutateTembusanList();

      closeModalForm();
    } catch (error) {
      toast.error("Gagal menyimpan data.");
    }
  };

  // Handler untuk mengubah pilihan di ReactSelect
  const handleSelectChange = (options) => {
    setSelectedItems(options || []);
    setValue("pejabatIds", options ? options.map((item) => item.value) : []);
    setHasUnsavedChanges(true);
  };

  // Drag and Drop Handlers
  const handleDragStart = (index) => {
    setDraggedItemIndex(index);
  };

  const handleDragEnter = (index) => {
    const items = Array.from(selectedItems);
    const draggedItem = items[draggedItemIndex];
    items.splice(draggedItemIndex, 1);
    items.splice(index, 0, draggedItem);
    setDraggedItemIndex(index);
    setSelectedItems(items);
    setValue(
      "pejabatIds",
      items.map((item) => item.value)
    );
  };

  const handleDragEnd = () => {
    setDraggedItemIndex(null);
    setHasUnsavedChanges(true);
  };

  // Handler untuk menghapus pejabat
  const handleDeleteItem = (id) => {
    const updatedItems = selectedItems.filter((item) => item.value !== id);
    setSelectedItems(updatedItems);
    setValue(
      "pejabatIds",
      updatedItems.map((item) => item.value)
    );
    setHasUnsavedChanges(true);
  };

  // Handler untuk submit list pejabat
  const onSubmitList = async () => {
    console.log("hit dong");
    try {
      const payload = {
        draftId: existingTembusan.draftSurat.id,
        tembusanIds: selectedItems?.map((item) => item.value),
      };
      if (registrasiId) {
        await simpanSK(registrasiId, payload);
      } else {
        await patchFetcherWithoutId("api/rekom/permohonan/draft-surat", payload);
      }
      setHasUnsavedChanges(false);
      toast.success("Daftar tembusan berhasil disimpan!");
    } catch (error) {
      toast.error("Gagal menyimpan daftar tembusan.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitList)}>
      <Card radius="sm" className="col-span-3 h-[500px] shadow-lg">
        <CardHeader>
          <div className="flex flex-col">
            <span className="text-md">Tembusan</span>
            {hasUnsavedChanges && <span className="text-red-500 text-xs">Perubahan belum disimpan</span>}
          </div>
          <div className="ml-auto">
            <Button isIconOnly size="sm" color="primary" onPress={() => openModalForm()}>
              <PlusIcon className="size-4" />
            </Button>
          </div>
        </CardHeader>

        <Divider />
        <CardBody className="text-sm">
          <Controller
            name="tembusanIds"
            control={control}
            render={({ field }) => (
              <ReactSelect
                label="Pilih Tembusan"
                isMulti
                options={tembusanList || []}
                isLoading={isLoading}
                value={selectedItems}
                onChange={handleSelectChange}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                styles={{
                  control: (provided) => ({ ...provided, fontSize: "14px" }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({ ...provided, maxHeight: "200px", overflowY: "auto" }),
                }}
              />
            )}
          />
          <div className="mt-4">
            <Table removeWrapper aria-label="table-pejabat">
              <TableHeader>
                {columns.map((col, index) => (
                  <TableColumn key={index}>{col}</TableColumn>
                ))}
              </TableHeader>
              <TableBody loadingContent={<Spinner />} loadingState={isLoading ? "loading" : "idle"} emptyContent="Tidak ada data">
                {selectedItems.map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      cursor: isDragging ? "grabbing" : "grab",
                      backgroundColor: isDragging ? "#DEF2F1" : "transparent",
                    }}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragEnter={() => handleDragEnter(index)}
                    onDragEnd={handleDragEnd}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.label}</TableCell>
                    <TableCell className="flex items-center gap-1">
                      <Button size="sm" onPress={() => openModalForm(item)} color="warning" isIconOnly>
                        <PencilSquareIcon className="size-4" />
                      </Button>
                      <Button size="sm" onPress={() => handleDeleteItem(item.value)} color="danger" isIconOnly>
                        <TrashIcon className="size-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="mt-4">
            <Button type="submit" color="primary" isDisabled={isSubmitting || selectedItems.length === 0}>
              Submit
            </Button>
          </div>
        </CardBody>

        {/* Modal Form Tambah/Edit Pejabat */}
        <Modal isOpen={isOpenModalForm} onOpenChange={setIsOpenModalForm} onClose={closeModalForm}>
          <ModalContent>
            <ModalHeader>{isEdit ? "Edit Tembusan" : "Tambah Tembusan"}</ModalHeader>
            <ModalBody>
              {isFetching ? (
                <Spinner />
              ) : (
                <>
                  <Input {...register("nama")} label="Nama" isRequired />
                  <Select {...register("tipe")} label="Tipe" isRequired>
                    {tipe.map((status) => (
                      <SelectItem key={status}>{status}</SelectItem>
                    ))}
                  </Select>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              <Button onPress={handleSubmit(onSubmitForm)} color="primary">
                {isEdit ? "Simpan" : "Tambah"}
              </Button>
              <Button onPress={closeModalForm} color="danger">
                Batal
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </form>
  );
}
